import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from './toast.service';

@Component({
  standalone: true,
  selector: 'app-toasts',
  imports: [NgbToastModule, NgTemplateOutlet],
  template: `
    @for (toast of toastService.toasts(); track toast) {
      <ngb-toast
        [class]="toast.class"
        [autohide]="true"
        [delay]="toast.delay || 5000"
        [attr.role]="isErrorToast(toast.class) ? 'alert' : 'status'"
        [attr.aria-live]="isErrorToast(toast.class) ? 'assertive' : 'polite'"
        [attr.aria-atomic]="'true'"
        (hidden)="toastService.remove(toast)"
      >
        @if (toast.template) {
          <ng-template [ngTemplateOutlet]="toast.template"></ng-template>
        } @else {
          {{ toast.content }}
        }
      </ngb-toast>
    }
  `,
  // Story 87.27 (AC 6): Bootstrap's `p-3`, but the top padding is the component's own, so that in the app opened from the
  // Home Screen the first toast sits 16 px below the status bar (`--app-safe-top` is 0 in a browser tab: 1rem, as before).
  styles: `
    :host {
      padding-top: calc(1rem + var(--app-safe-top, 0px));
    }
  `,
  host: {
    class: 'toast-container position-fixed top-0 end-0 px-3 pb-3',
    style: 'z-index: 1200',
    role: 'region',
    'aria-label': 'Notifications',
  },
})
export class ToastsContainerComponent {
  toastService = inject(ToastService);

  // Error toasts announce assertively (interrupt current reading) because an
  // error is important; successes announce politely so the user hears them
  // without losing focus. Classifier matches the Bootstrap contextual class
  // set by ToastService.error() ('bg-danger …').
  isErrorToast(klass: string | undefined): boolean {
    return typeof klass === 'string' && klass.includes('bg-danger');
  }
}
